import { NormalizeOAS, OASRequestParams, OASResponse } from 'fets';
import type assetLibraryOpenApi from '../asset-library-open-api';
import { AssetLibraryFetsApiClient } from '../asset-library-fets-client';
import { assertNever } from '../utils';
import { Guid } from '../../api/public/utils/Guid';

const PATH = '/api/v2/asset/company/{companyId}/asset/{assetId}/archive';

type Params = {
  companyId: Guid;
  assetId: Guid;
};

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<void>;

export const createArchiveAsset = (apiClient: AssetLibraryFetsApiClient): ApiFunction => {
  const archiveAsset = async (params: Params, signal?: AbortSignal): Promise<void> => {
    const response = await apiClient[PATH].post({
      ...convertToRequest(params),
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return archiveAsset;
};

type Request = OASRequestParams<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;
type Response = OASResponse<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'post'>;

const convertToRequest = (params: Params): Request => ({
  params: { companyId: params.companyId, assetId: params.assetId },
});

const convertResponse = async (response: Response): Promise<void> => {
  const responseStatus = response.status;
  if (responseStatus !== 204 && responseStatus !== 404) {
    return assertNever(responseStatus);
  }
};
